import httpStore from "@/api/httpStore.js";

export function getOrderSyncStats(fromDate, toDate, departamentoId = "") {
  let url = `/nkrsync/stats_orders?from=${fromDate}&to=${toDate}`;
  if (departamentoId) {
    url += `&departamento_id=${encodeURIComponent(departamentoId)}`;
  }
  return httpStore.get(url).then(res => {
    return res.data;
  });
}

export function getStatsGeodecode(limit = 500) {
  const url = `/nkrsync/stats_geodecode?limit=${limit}`;
  return httpStore.get(url).then(res => {
    return res.data;
  });
}
